import { posthog } from 'posthog-js'
import { abmeldungDigitalPosthogKeyDevelopment, abmeldungDigitalPosthogKeyProduction } from '@gks/constants'

export default defineNuxtPlugin(() => {
  const publicKey = useRuntimeConfig().public.target === 'production' ? abmeldungDigitalPosthogKeyProduction : abmeldungDigitalPosthogKeyDevelopment
  
  const posthogClient = posthog.init(publicKey, {
    api_host: 'https://eu.i.posthog.com',
    capture_pageview: true,
    autocapture: false,
    disable_surveys: true,
    disable_web_experiments: true,
    disable_session_recording: true,
    person_profiles: 'identified_only',
    // debug: useRuntimeConfig().public.target !== 'production'
  })
  
  // const router = useRouter()

  // router.afterEach((to) => {
  //   nextTick(() => {
  //     posthog.capture('$pageview', {
  //       current_url: to.fullPath
  //     })
      
  //     if (to.fullPath.includes('neues-kennzeichen')) {
  //       posthogClient?.startSessionRecording()
  //     }
  //   })
  // })


  return {
    provide: {
      posthog: posthogClient
    }
  }
})
